import { UserType } from "types/UserType";
import { isValidPhoneNumber } from "react-phone-number-input";

import {FieldsConfig, FormEmailAndPhoheScreenValues, FormValues} from "./Registration";

const REQUIRED = "Поле обязательно для заполнения";

const isValidBirthDate = (value: string) => {
  if (!value) {
    return false;
  }

  const parts = value.split(".").reverse().map(Number) as [
    number,
    number,
    number
  ];

  if (parts.length !== 3) {
    return false;
  }

  const date = new Date(parts[0], parts[1] - 1, parts[2]);

  if (isNaN(date.valueOf())) {
    return false;
  }

  if (date.valueOf() > Date.now()) {
    return false;
  }

  if (
    date.getDate() !== parts[2] ||
    date.getMonth() !== parts[1] - 1 ||
    date.getFullYear() !== parts[0]
  ) {
    return false;
  }

  return true;
};

const isValidEmail = (email: string) => {
  if(!email) {
    return false
  }
  return /^[-A-Za-z0-9!#$%&'*+/=?^_`{|}~]+(?:\.[-A-Za-z0-9!#$%&'*+/=?^_`{|}~]+)*@(?:[A-Za-z0-9]([-A-Za-z0-9]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]+$/i.test(email)
}

export const createValidation =
  (
    fieldsConfig: FieldsConfig,
  ) => (values: FormValues) => {
    let errors: { [key in keyof FormValues]?: string } = {};

    const fieldsToValidate = [
      fieldsConfig?.name?.isVisible && fieldsConfig?.name?.isRequired ? "custom_firstname" : null,
      fieldsConfig?.lastname?.isVisible && fieldsConfig?.lastname?.isRequired ? "custom_lastname" : null,
      fieldsConfig?.midname?.isVisible && fieldsConfig?.midname?.isRequired ? "custom_midname" : null,
      fieldsConfig?.birthday?.isVisible ? "custom_дата_рождения" : null,
      fieldsConfig?.gender?.isVisible ? "custom_sexint_save" : null,
      fieldsConfig?.phone?.isVisible && fieldsConfig?.phone?.isRequired ? "custom_телефон" : null,
      fieldsConfig?.email?.isVisible && fieldsConfig?.email?.isRequired ? "custom_login" : null,
      fieldsConfig?.country?.isVisible && fieldsConfig?.country?.isRequired ? "custom_страна" : null,
      fieldsConfig?.city?.isVisible && fieldsConfig?.city?.isRequired ? "custom_город" : null,
      fieldsConfig?.address?.isVisible && fieldsConfig?.address?.isRequired ? "custom_адрес" : null,
    ].filter(Boolean) as (keyof FormValues)[];

    fieldsToValidate.forEach((field) => {
      if (!values[field]) {
        errors[field] = REQUIRED;
      }
    });

    if (fieldsConfig?.birthday?.isVisible && values.custom_дата_рождения && !isValidBirthDate(values.custom_дата_рождения)) {
      errors.custom_дата_рождения =
        errors.custom_дата_рождения || "Некорректная дата";
    }

    if (fieldsConfig?.phone?.isVisible && values.custom_телефон && !isValidPhoneNumber(values.custom_телефон || "")) {
      errors.custom_телефон = errors.custom_телефон || "Некорректный номер";
    }

    if(fieldsConfig?.email?.isVisible && values.custom_login && !isValidEmail(values.custom_login || "")) {
      errors.custom_login = "Введите корректную почту"
    }

    if (Object.keys(errors).length) {
      return errors;
    }

    return undefined;
  };

export const epharmacyFormValidator =
  (
    fieldsConfig: Partial<FieldsConfig>
  ) => (values: FormValues) => {
  let errors: { [key in keyof FormValues]?: string } = {};

  const fieldsToValidate = [
    fieldsConfig?.birthday?.isVisible ? "custom_дата_рождения" : null,
    fieldsConfig?.gender?.isVisible ? "custom_sexint_save" : null,
  ].filter(Boolean) as (keyof FormValues)[];
  const numberFields = ["custom_масса_тела", "custom_рост"] as const;

  fieldsToValidate.forEach((field) => {
    if (!values[field]) {
      errors[field] = REQUIRED;
    }
  });

  if (fieldsConfig?.birthday?.isVisible && values.custom_дата_рождения && !isValidBirthDate(values.custom_дата_рождения)) {
    errors.custom_дата_рождения =
      errors.custom_дата_рождения || "Некорректная дата";
  }

  numberFields.forEach((key) => {
    const value = values[key] as string;

    if (!value) {
      return;
    }

    const isValid = /^(?:0,(?!0{1,2})\d{1,2}|[1-9]\d{0,2}(?:,\d{1,2})?)$/.test(value);

    if (!isValid) {
      errors[key] = "Некорректное значение";
    }
  });

  if (Object.keys(errors).length) {
    return errors;
  }

  return undefined;
};

export const emailFormValidation = (values: FormValues) => {
  let errors: { [key in keyof FormValues]?: string } = {};

  const requiredFields = [
    "custom_email_for_pdf" as const,
  ].filter(Boolean) as (keyof FormValues)[];

  requiredFields.forEach((key) => {
    if (!values[key]) {
      errors[key] = REQUIRED;
    }
  });

  const isValid = isValidEmail(values.custom_email_for_pdf || "")

  if(!isValid) errors.custom_email_for_pdf =  "Введите корректную почту"

  if (Object.keys(errors).length) {
    return errors;
  }

  return undefined;
};

type validationInfo = {
  phone: {
    showPhoneField : boolean,
    isPhoneRequired: boolean
  },
  email: {
    showEmailField : boolean,
    isEmailRequired: boolean
  }
}

export const phoneAsFioFormValidation = (values: FormEmailAndPhoheScreenValues, validationInfo: validationInfo) => {
  let errors: { [key in keyof FormEmailAndPhoheScreenValues]?: string } = {};

  const fieldsToValidate = [
    validationInfo?.phone?.showPhoneField && validationInfo?.phone?.isPhoneRequired ? "custom_phone" : null,
    validationInfo?.email?.showEmailField && validationInfo?.email?.isEmailRequired ? "custom_login" : null
  ].filter(Boolean) as (keyof FormEmailAndPhoheScreenValues)[];

  fieldsToValidate.forEach((field) => {
    if (!values[field]) {
      errors[field] = REQUIRED;
    }
  });

  if (validationInfo?.phone?.showPhoneField && values.custom_phone && !isValidPhoneNumber(values.custom_phone || "")) {
    errors.custom_phone = "Введите корректный номер телефона";
  }

  if(validationInfo?.email?.showEmailField && values.custom_login && !isValidEmail(values.custom_login || "")) {
    errors.custom_login = "Введите корректную почту"
  }

  if (Object.keys(errors).length) {
    return errors;
  }

  return undefined;
};